import { NgModule} from '@angular/core';
import { MaterialModule,MdTabsModule } from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FOCRequestsRoutingModule } from './foc-requests-routing.module';
import { FileUploadModule } from '../fileUpload.module';
import { TranslateModule } from 'ng2-translate';
import { FOCRequestsComponent} from './foc-requests.component';
import { FOCRequestAddComponent } from './foc-create/foc-request_add.component';
import { FOCRequestReturnComponent } from './foc-return/foc-return.component';
import { FOCRequestConfirmComponent } from './foc-confirm/foc-confirm.component';
import { MdAutocompleteModule, MdInputModule, MdOptionModule } from '@angular/material';

@NgModule({
    imports: [
        MaterialModule,
        MdTabsModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        FOCRequestsRoutingModule,
        FileUploadModule,
        TranslateModule,
        MdAutocompleteModule,
        MdInputModule,
        MdOptionModule,

    ],
    declarations: [
        FOCRequestsComponent,
        FOCRequestAddComponent,
        FOCRequestReturnComponent,
        FOCRequestConfirmComponent,
    ],
    exports: [
        
    ]
})

export class FOCRequestsModule {}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/request-mgmt-foc/foc-requests.module.ts